import { Anchor as PopoverAnchor } from '@radix-ui/react-popover';
import { useRef, useState } from 'react';
import { BaseCell } from 'src/components/TableV2/cells';
import { Popover, Stack } from 'src/core/ui';

import { RetailUnpaidSale } from '../RetailTable.types';
import * as styles from './RetailTableComponents.css';
import { SalePill } from './SalePill';
import { SaleSearchPopover } from './SaleSearchPopover';

export function UnpaidSalesCell({
  sales,
  onOpenSale,
}: {
  sales: RetailUnpaidSale[];
  onOpenSale: (sale: RetailUnpaidSale) => void;
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <Popover.Root onOpenChange={(open) => !open && setSearchQuery('')}>
      <BaseCell style={{ minWidth: 0, padding: 0 }}>
        <PopoverAnchor asChild>
          <Stack
            ref={anchorRef}
            justifyContent="spaceBetween"
            alignItems="center"
            className={styles.cellLayout}
          >
            <div className={styles.pillsOverflow}>
              <Stack gap="s">
                {sales.map((sale) => (
                  <SalePill
                    key={sale.id}
                    label={sale.label}
                    onOpen={() => onOpenSale(sale)}
                  />
                ))}
              </Stack>
            </div>
            <SaleSearchPopover
              sales={sales}
              onOpenSale={onOpenSale}
              searchQuery={searchQuery}
              onSearchQueryChange={setSearchQuery}
              anchorRef={anchorRef}
            />
          </Stack>
        </PopoverAnchor>
      </BaseCell>
    </Popover.Root>
  );
}
